export default {
  data: [
    {
      id: 1,
      desingName: "Diseño 1",
      articleId: 1,
      furnace: {
        corriente: 600,
        frecuencia: 10,
        tiempoExposicion: 50,
        temperature: 900,
        heating_ramp: 100,
        piece_temperrature: 35
      },
      quenching: {
        tiempoExposicion: 50,
        caudal: 0.25,
        medio:"aire",
        bath_type: "water",
        bath_temperature: 50,
        agitation_level: 2,
        hard_coat: 30

      },
      tempered: {
        corriente: 950,
        frecuencia: 450,
        tiempoExposicion: 50
      },
      date: "2020-02-10T13:52:39+01:00",
      recommendation: {
        furnace_time: 37800,
        quenching: 30,
        tempered_time: 23400
      },
      forja:{
        nPasadas:{
          name:"nPasadas",
          name2:"",
          valor:2,
          suf:""
        },
        AltI:{
          name:"AltI",
          name2:"",
          valor:64,
          suf:" mm"
        },
        AltF:{
          name:"AltF",
          name2:"",
          valor:2,
          suf:" mm"
        },
        AltIP1:{
          name:"AltIP",
          name2:"1",
          valor:64,
          suf:" mm"
        },
        AltIF1:{
          name:"AltF",
          name2:"1",
          valor:30,
          suf:" mm"
        },
        Tap1:{
          name:"Tap",
          name2:"1",
          valor:0.8,
          suf:" s"
        },
        Tep1:{
          name:"Tep",
          name2:"1",
          valor:10,
          suf:" s"
        },
        AltIP2:{
          name:"AltIP",
          name2:"2",
          valor:30,
          suf:" mm"
        },
        AltIF2:{
          name:"AltF",
          name2:"2",
          valor:2,
          suf:" mm"
        },
        Tap2:{
          name:"Tap",
          name2:"2",
          valor:1.2,
          suf:" s"
        },
        Tep2:{
          name:"Tep",
          name2:"2",
          valor:10,
          suf:" s"
        }
      }
    },
    {
      id: 2,
      desingName: "Diseño 2",
      articleId: 2,
      furnace: {
        corriente: 650,
        frecuencia: 15,
        tiempoExposicion: 45,
        temperature: 900,
        heating_ramp: 100,
        piece_temperrature: 35

      },
      quenching: {
        tiempoExposicion: 45,
        bath_type: "emulsion",
        medio:"aire",
        caudal: 0.25,
        bath_temperature: 50,
        agitation_level: 2,
        hard_coat: 30
      },
      tempered: {
        corriente: 1000,
        frecuencia: 500,
        tiempoExposicion: 45
      },
      date: "2020-02-10T18:52:39+01:00",
      recommendation: {
        furnace_time: 34200,
        quenching: 35,
        tempered_time: 21600
      },
      forja:{
        nPasadas:{
          name:"nPasadas",
          name2:"",
          valor:3,
          suf:""
        },
        AltI:{
          name:"AltI",
          name2:"",
          valor:75,
          suf:" mm"
        },
        AltF:{
          name:"AltF",
          name2:"",
          valor:2,
          suf:" mm"
        },
        AltIP1:{
          name:"AltIP",
          name2:"1",
          valor:75,
          suf:" mm"
        },
        AltIF1:{
          name:"AltF",
          name2:"1",
          valor:45,
          suf:" mm"
        },
        Tap1:{
          name:"Tap",
          name2:"1",
          valor:0.7,
          suf:" s"
        },
        Tep1:{
          name:"Tep",
          name2:"1",
          valor:10,
          suf:" s"
        },
        AltIP2:{
          name:"AltIP",
          name2:"2",
          valor:45,
          suf:" mm"
        },
        AltIF2:{
          name:"AltF",
          name2:"2",
          valor:20,
          suf:" mm"
        },
        Tap2:{
          name:"Tap",
          name2:"2",
          valor:1.1,
          suf:" s"
        },
        Tep2:{
          name:"Tep",
          name2:"2",
          valor:10,
          suf:" s"
        },
        AltIP3:{
          name:"AltIP",
          name2:"3",
          valor:20,
          suf:" mm"
        },
        AltIF3:{
          name:"AltF",
          name2:"3",
          valor:2,
          suf:" mm"
        },
        Tap3:{
          name:"Tap",
          name2:"3",
          valor:1.4,
          suf:" s"
        },
        Tep3:{
          name:"Tep",
          name2:"3",
          valor:10,
          suf:" s"
        }
      }
    }
  ]
};

